var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.862,
    height: 12.569,
    viewBox: "0 0 6.862 12.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Facebook",
    d: "M220.561,179.818h2.307v-5.733h1.924l.288-2.234h-2.213v-1.426c0-.647.18-1.088,1.107-1.088h1.183v-2a15.81,15.81,0,0,0-1.724-.088,2.692,2.692,0,0,0-2.874,2.953v1.648h-1.929v2.234h1.929v5.733Z",
    transform: "translate(-218.297 -167.25)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.127c4093.svg";
export { ForwardRef as ReactComponent };